import axios from 'axios'
import { BUSCAR_DIAS_SEMANA_CONTROLE_EMISSAO_BPE } from '../types'
import { URL } from '../../util/ambienteActions';

export default function buscarDiasSemanaControleEmissaoBpe (empresaId) {
  const url = `${URL}/controle-emissao-bpe/dias-semana/empresa/${empresaId}`;

  return dispatch => axios.get(url).then(
      response => {
        dispatch({
          type: BUSCAR_DIAS_SEMANA_CONTROLE_EMISSAO_BPE,
          payload: response
        });
        return { payload: response };
      }
  );
}
